import themeVariables from './themes.module.scss';
const themeNameKey = 'var-theme-name';
const baseColorsSetPrefix = 'var-base-color-set-';
const baseColorsSetDescriptionPrefix = 'var-base-color-setdescription-';
const baseColorsPrefix = 'var-base-color-';
const palettesNamePrefix = 'var-palette-name-';
const paletteSetPrefix = 'var-palette-';
const storybookColorSetPrefix = 'var-storybook-color-set-';
const storybookColorPrefix = 'var-storybook-color-';
const storybookFontsSetPrefix = 'var-storybook-font-set-';
const storybookFontsPrefix = 'var-storybook-font-';
const otherSpacingsPrefix = 'var-other-spacings-';
const responsiveWidthPrefix = 'var-responsive-width-';
const breakpointPrefix = 'var-breakpoint-';
const containerWidthPrefix = 'var-container-width-';
const transitionsPrefix = 'var-transitions-';
const zindexPrefix = 'var-z-index-';
/**
 * Unfortunately, this approach is not performant.
 * If we need to import just 2 keys, all keys will be added to production bundle (including unused ones)
 */
const getNamesFromPrefix = (prefix) => {
    return Object.keys(themeVariables)
        .filter((variable) => variable.includes(prefix))
        .map((name) => name.replace(prefix, ''));
};
const getSetFromPrefix = (prefix) => {
    return Object.keys(themeVariables)
        .filter((variable) => variable.includes(prefix))
        .reduce((set, name) => {
        const key = name.replace(prefix, '');
        return Object.assign(Object.assign({}, set), { [key]: themeVariables[name] });
    }, {});
};
const getBaseColors = () => {
    const baseColorsNames = getNamesFromPrefix(baseColorsSetPrefix);
    return baseColorsNames.reduce((baseColors, name) => (Object.assign(Object.assign({}, baseColors), { [name]: getSetFromPrefix(`${baseColorsPrefix}${name}-`), descriptions: Object.assign(Object.assign({}, baseColors.descriptions), { [name]: themeVariables[`${baseColorsSetDescriptionPrefix}${name}`] }) })), { descriptions: {} });
};
const getPalettes = () => {
    const paletteNames = getNamesFromPrefix(palettesNamePrefix);
    return paletteNames.reduce((palettes, name) => (Object.assign(Object.assign({}, palettes), { [name]: getSetFromPrefix(`${paletteSetPrefix}${name}-`) })), {});
};
const getStorybookColors = () => {
    const colorSetNames = getNamesFromPrefix(storybookColorSetPrefix);
    return colorSetNames.reduce((colorSets, name) => (Object.assign(Object.assign({}, colorSets), { [name]: getSetFromPrefix(`${storybookColorPrefix}${name}-`) })), {});
};
const getStorybookFontCollections = () => {
    const fontSets = {};
    const fontSetNames = getNamesFromPrefix(storybookFontsSetPrefix);
    const fontSubSetNames = [
        'body-text',
        'button',
        'cta-link',
        'display',
        'heading',
        'price',
        'preamble',
        'navigation',
    ];
    const fontSubSetObjectNames = [
        'default-size',
        'breakpoint-xsmall',
        'breakpoint-small',
        'breakpoint-medium',
        'breakpoint-large',
        'breakpoint-xlarge',
    ];
    fontSetNames.forEach((setName) => {
        fontSubSetNames.forEach((subSetName) => {
            const key = setName.replace(`${subSetName}-`, '');
            if (!setName.includes(subSetName)) {
                return;
            }
            const fontSubSetObjects = {};
            const fontSet = getSetFromPrefix(`${storybookFontsPrefix}${setName}-`);
            fontSubSetObjects[key] = fontSet;
            Object.keys(fontSet).forEach((setKey) => {
                fontSubSetObjectNames.forEach((setObjectName) => {
                    if (setKey.includes(setObjectName)) {
                        fontSubSetObjects[key][setObjectName] = getSetFromPrefix(`${storybookFontsPrefix}${setName}-${setObjectName}-`);
                        delete fontSubSetObjects[key][setKey];
                    }
                });
            });
            fontSets[subSetName] = Object.assign(Object.assign({}, fontSets[subSetName]), fontSubSetObjects);
        });
    });
    return fontSets;
};
export const getThemesLayoutTransitions = () => getSetFromPrefix(transitionsPrefix);
const getThemesLayout = () => ({
    other: getSetFromPrefix(otherSpacingsPrefix),
    responsiveWidth: getSetFromPrefix(responsiveWidthPrefix),
    breakpoints: getSetFromPrefix(breakpointPrefix),
    containerWidth: getSetFromPrefix(containerWidthPrefix),
    transitions: getSetFromPrefix(transitionsPrefix),
    zindex: getSetFromPrefix(zindexPrefix),
});
export const getThemesJson = () => {
    const themeName = themeVariables[themeNameKey];
    const baseColors = getBaseColors();
    const palettes = getPalettes();
    const storybook = { colors: getStorybookColors(), fonts: getStorybookFontCollections() };
    const layout = getThemesLayout();
    return { themeName, baseColors, palettes, storybook, layout };
};
export const getPaletteName = (palette) => {
    return `palette-${palette || 'default'}`;
};
export default getThemesJson();
//# sourceMappingURL=themes.js.map